var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu-item",
    {
      staticClass: "el-menu-item__custom",
      class: _vm.selectedMenuItemClass,
      attrs: { index: _vm.index, route: _vm.route },
    },
    [
      _c(
        "div",
        {
          staticClass: "menu-item__container",
          class: _vm.upDownBorderClass,
          on: {
            mouseover: function ($event) {
              _vm.hover = true
            },
            mouseleave: function ($event) {
              _vm.hover = false
            },
          },
        },
        [
          _c("img", { staticClass: "icon", attrs: { src: _vm.computedIcon } }),
          _vm._v(" "),
          _c("span", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.description)),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }